import { DownOutlined } from '@ant-design/icons';
import { Field, useFormContext } from '@oscar/form';
import { Col, Row, Select, Icon } from '@oscar/theme';
import { TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { useAuth } from 'features/auth';
import moment from 'moment';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import { State } from '../../typed';

const { Option } = Select;

interface Props {
  statusRequest: StatusInstance;
}

export const RequestorDetail = ({ statusRequest: { state, id } }: Props) => {
  const [formContext] = useFormContext();
  const [auth] = useAuth();
  const metaDataRequestor =
    formContext.selectors?.getDataByKey('metaDataRequestorDetail') || {};
  return (
    <div className="requestor-detail">
      <>
        <Row gutter={[20, 20]}>
          <Col span={24}>
            {state === 'VIEW' || (state === 'EDIT' && !!id) ? (
              <Field name="name">
                <TextField label="Name" />
              </Field>
            ) : (
              <TextField
                label="Name"
                value={auth.getUserInformation()?.fullName}
              />
            )}
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          <Col span={8}>
            {state === 'VIEW' || (state === 'EDIT' && !!id) ? (
              <Field name="position">
                <TextField label="Position" />
              </Field>
            ) : (
              <TextField
                label="Position"
                value={auth.getUserInformation()?.position}
              />
            )}
          </Col>
          <Col span={8}>
            {state === 'VIEW' || (state === 'EDIT' && !!id) ? (
              <Field name="department">
                <TextField label="Department" />
              </Field>
            ) : (
              <TextField
                label="Department"
                value={auth.getUserInformation()?.department}
              />
            )}
          </Col>
          <Col span={8}>
            {state === 'VIEW' || (state === 'EDIT' && !!id) ? (
              <Field name="requestedDate">
                <TextField
                  label="Request Date"
                  isDate
                  formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
                />
              </Field>
            ) : (
              <TextField
                label="Request Date"
                value={moment().format(FORMAT_DATE.SHORT_MONTH_DATE)}
              />
            )}
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={state === 'VIEW' ? 8 : 12}>
            {state === 'VIEW' ? (
              <Field name="section">
                <TextField
                  label="Section"
                  mappingData={metaDataRequestor?.section}
                />
              </Field>
            ) : (
              <>
                <p className="label-normal">Section</p>
                <Field name="section">
                  <Select
                    size="large"
                    placeholder="Search for Section"
                    showSearch
                    className="select-search"
                    dropdownClassName="certain-category-search-dropdown"
                    filterOption={(input: any, option: any) =>
                      option.children
                        ?.toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    allowClear
                    suffixIcon={<Icon icon="search" size={18} />}
                  >
                    {metaDataRequestor?.section?.map?.(
                      (item: any, index: number) => (
                        <Option key={`${item.id}-${index}`} value={item?.id}>
                          {item.label}
                        </Option>
                      ),
                    )}
                  </Select>
                </Field>
              </>
            )}
          </Col>
          {state === 'VIEW' ? (
            <Col span={16}>
              <Field name="discipline">
                <TextField
                  label="Discipline"
                  mappingData={metaDataRequestor?.discipline}
                />
              </Field>
            </Col>
          ) : (
            <>
              <Col span={12}>
                <p className="label-normal">Discipline</p>
                <Field name="discipline">
                  <Select
                    placeholder="Select Discipline"
                    suffixIcon={<DownOutlined />}
                    className="discipline"
                    allowClear
                    size="large"
                  >
                    {metaDataRequestor?.discipline?.map?.(
                      (item: any, index: number) => (
                        <Option key={`${item}-${index}`} value={item?.id}>
                          {item.label}
                        </Option>
                      ),
                    )}
                  </Select>
                </Field>
              </Col>
            </>
          )}
        </Row>
      </>
    </div>
  );
};

export default RequestorDetail;
